import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
//import harData from './example.har';
import {getBaseElements} from '../../../../../services/getBaseElements'
// Component styles
import moment from 'moment'
import 'moment/locale/es'
import { AtCircularProgress } from '../../../../../components/AtCircularProgress/index.jsx';
import { NewPlusRegisters } from '../../NewPlusRegisters/index.jsx';
import { getRegistersPlusByObjective } from '../../../../../services/getRegistersPlus/index.js';
import set from 'date-fns/esm/set/index';
import { Alert } from '@material-ui/lab';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class BaseDataRegisters extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            isLoad:true,
            objective:this.props.objective,
            nodes:this.props.nodes,
            steps:this.props.steps,
            begin:this.props.dateBegin.format("YYYY-MM-DD H:mm:ss"),
            final:this.props.dateFinal.format("YYYY-MM-DD H:mm:ss"),
            dates:[],
            isError: false,
        };
        this.profileId = sessionStorage.getItem("profile_id");
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dateBegin.format("YYYY-MM-DD H:mm:ss") !== state.begin||props.dateFinal.format("YYYY-MM-DD H:mm:ss")!==state.final) {
            return {
                isLoad:true,
                begin:props.dateBegin.format("YYYY-MM-DD H:mm:ss"),
                final:props.dateFinal.format("YYYY-MM-DD H:mm:ss"),
                dates:[]
            }
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if(prevProps.dateBegin.format("YYYY-MM-DD H:mm:ss")!== this.state.begin||prevProps.dateFinal.format("YYYY-MM-DD H:mm:ss")!== this.state.final){
            this.processData();
        }
    }

    componentDidMount() {
        this.processData();
    }

    getFetchs = (objective, nodes, begin, final, token, id_user) =>{
        return new Promise((resolve, reject) => {
            var List = []
            var fetches = []            
            nodes.forEach((value, key)=>{
                var monitor_id=(value.monitor)
                var getData=getBaseElements(objective, monitor_id, begin, final, token, id_user)
                fetches.push(                    
                    getData.then( data =>  { 
                        List[key] = {"fechas":data, "dataNodo":value}
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(List);
            })      
        });
    }
   
    processData = async () => {
        this.setState({isError: false})
        const { objective, nodes, begin, final}=this.state
        nodes.sort(function (a, b) {
            return (a.id_nodo - b.id_nodo);
        });
        let token = sessionStorage.getItem('key')
        let id_user = sessionStorage.getItem('user')
        try {
            const data = await this.getFetchs(objective, nodes, begin, final, token, id_user)
            const result = await Promise.all(data.map(async (item) => {
                const steps = await Promise.all(item.fechas.map(async (date) => {
                    const response = await getRegistersPlusByObjective(objective, item.dataNodo.id_nodo, token, date.fecha, id_user)
                    const data = await response.json();
                    let processedData = data;
                    if (data && Array.isArray(data) && this.profileId !== '1') {
                        processedData = data.map(register => {
                            let registros = []
                            if (register.registros && Array.isArray(register.registros)) {
                                registros = register.registros.filter(reg => {
                                    if ('@nombre' in reg) {
                                        // Se ignoran registros cuyo nombre comienza con "atinterno_"
                                        return !reg['@nombre'].startsWith('atinterno_');
                                    }
                                    return true;
                                })
                                return { ...register, registros : registros }
                            }
                            return register;
                        })
                    }
                    return { ...date, steps: processedData }
                }))
                return { ...item, fechasSteps: steps }
            }))
            this.setState({
                isLoad:false,
                dates:result
            })
        } catch(e) {
            console.error(e);
            this.setState({isError: true})
        } finally {
            this.setState({
                isLoad:false,
            })
        }
    }

    render() {
        const { isLoad, objective} = this.state;
        const { showOnlyWithRegisters } = this.props;
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (isLoad===true) {
            return(
                <AtCircularProgress />
            )
        }
        if (this.state.isError) {
            return <Alert severity='error'>{t('base-data-registers.alert.error.description')}</Alert>
        }
        return(
            <>
                <NewPlusRegisters data={this.state.dates} objective={objective} showOnlyWithRegisters={showOnlyWithRegisters} esIVR={this.props.esIVR} />
            </>
        )
    }
}



export default compose(withRouter, withStyles(styles), withTranslation())(BaseDataRegisters);